import {
	Component,
	ElementRef,
	Input,
	ViewChild,
	AfterViewInit,
} from '@angular/core';
import { Note } from './note.type';

@Component({
	selector: 'child-note-detail',
	templateUrl: './child-note.detail.component.html',
	styleUrls: ['./child-notes.component.css'],
})
export class ChildNoteDetailComponent implements AfterViewInit {
	@Input() note!: Note;
	@ViewChild('content') content!: ElementRef;
	isTruncated: boolean = false;

	ngAfterViewInit(): void {
		const contentElement = this.content.nativeElement;
		const scrollHeight = contentElement.scrollHeight;
		console.log('scrollHeight', scrollHeight);

		if (scrollHeight >= 50) {
			this.isTruncated = true;
		}
	}
}
